import React, { useContext, useEffect } from "react"
import { Table } from "antd"
import { Zone } from "@/types/zones.types"
import { defaultGlobalMapState, globalMapAtom } from "@/atoms/globalMapAtom"
import { KosmoMapContext } from "@/modules/shared/Map/MapProvider"
import { useSetRecoilState } from "recoil"
import { useMediaQuery } from "usehooks-ts"

interface ZonesTableProps {
  zones: Zone[]
}

const ZonesTable: React.FC<ZonesTableProps> = ({ zones }) => {
  const mapContext = useContext(KosmoMapContext)

  const setGlobalMapState = useSetRecoilState(globalMapAtom)

  const [selectedZone, setSelectedZone] = React.useState<Zone | null>(null)
  const columns = [
    {
      dataIndex: "name",
      key: "0",
      width: "70%",
      render: (name: string) => <p className="capitalize">{name}</p>,
    },
    {
      dataIndex: "color",
      key: "2",
      width: "20%",
      render: (color: string) => (
        <div
          className="w-4 h-4 rounded-full"
          style={{
            backgroundColor: color,
          }}
        />
      ),
    },
    // { key: "4", width: "10%", render: (zone: Zone) => <ZonesTableActionsCell zone={zone} /> },
  ]

  useEffect(() => {
    setGlobalMapState({
      current: { zones, selectedZone, setSelectedZone },
      prev: null,
    })
  }, [selectedZone, zones])

  useEffect(() => {
    return () => setGlobalMapState({ current: defaultGlobalMapState, prev: null })
  }, [])
  const isMobile = useMediaQuery("(max-width: 950px)")
  return (
    <div className="flex flex-row space-x-2 overflow-x-scroll">
      <div className="flex flex-col w-3/12 min-w-[130px]">
        <Table
          dataSource={zones}
          columns={columns}
          showHeader={false}
          rowKey={(record) => record.id}
          pagination={false}
          scroll={{ y: 750 }}
          onRow={(record) => {
            return {
              onMouseEnter: () => {
                setSelectedZone(record)
              },
              onMouseLeave: () => {
                setSelectedZone(null)
              },
            }
          }}
        />
      </div>
      <div
        className={`${isMobile ? "w-11/12" : "w-10/12"} sticky top-0`}
        style={{
          height: isMobile ? "550px" : "800px",
        }}
      >
        {mapContext?.KosmoMap && <mapContext.KosmoMap />}
      </div>
    </div>
  )
}

export default ZonesTable
